import gql from "graphql-tag";
import cookie from "../libraries/cookie";

export default {
	data() {
		return {
			loadedSchool: false,
			defaultDocument: {
				public_url: "",
				label: "",
			},
		};
	},
	computed: {
		_dataProcessingAgreement() {
			if (!this.loadedSchool) {
				return this.defaultDocument;
			}

			return this._getDocument("data_processing_agreement");
		},
		_termsOfUse() {
			if (!this.loadedSchool) {
				return this.defaultDocument;
			}

			return this._getDocument("terms_of_use");
		},
		_termsAndConditions() {
			if (!this.loadedSchool) {
				return this.defaultDocument;
			}

			return this._getDocument("licence_terms");
		},
		_privacyNotice() {
			if (!this.loadedSchool) {
				return this.defaultDocument;
			}

			return this._getDocument("privacy_notice");
		},
	},
	apollo: {
		_SchoolPrivate: {
			client: "private",
			query: gql`
				query GetPrivateSchool($companyId: String) {
					User {
						id
						School {
							id
							shard_id
							show_welsh_dha
							welsh_dha_agreed_at
							Country {
								id
								LegalDocuments(companyId: $companyId) {
									id
									label
									type
									public_url
								}
							}
						}
					}
				}
			`,
			update: (r) => r.User.School,
			variables() {
				return {
					companyId: this.documentsCompanyId || null,
				};
			},
			skip() {
				return !cookie.doesLoginCookieExist();
			},
			result() {
				this.loadedSchool = true;
			},
		},
		_SchoolPublic: {
			client: "public",
			query: gql`
				query GetPublicSchool($id: String!) {
					School(id: $id) {
						id
						shard_id
						show_welsh_dha
						welsh_dha_agreed_at
						Country {
							id
							LegalDocuments {
								id
								label
								type
								public_url
							}
						}
					}
				}
			`,
			update: (r) => r.School,
			skip() {
				return cookie.doesLoginCookieExist();
			},
			variables() {
				return {
					id: this._schoolId || this.$route.params.school,
				};
			},
			result() {
				this.loadedSchool = true;
			},
		},
		DefaultLegalDocuments: {
			client: "public",
			query: gql`
				{
					DefaultLegalDocuments {
						id
						label
						type
						public_url
					}
				}
			`,
		},
	},
	methods: {
		_getDocument(type) {
			const school = this._SchoolPublic || this._SchoolPrivate;

			if (!school) {
				return this.defaultDocument;
			}

			if (school && school.show_welsh_dha && school.welsh_dha_agreed_at && type === "data_processing_agreement") {
				return this._getWelshDPA();
			}

			if (this._getStaticDocument(type)) {
				return this._getStaticDocument(type);
			} else if (school) {
				return school.Country.LegalDocuments.find((legalDocument) => {
					return legalDocument.type === type;
				});
			} else if (this.DefaultLegalDocuments) {
				return this.DefaultLegalDocuments.find((legalDocument) => {
					return legalDocument.type === type;
				});
			}

			return this.defaultDocument;
		},
		_getStaticDocument(type) {
			const links = {
				licence_terms: {
					public_url: "https://wonde.com/downloads/Wonde - Licence Terms and conditions.pdf",
					label: "Wonde's License Terms",
				},
			};

			return links[type];
		},
		_getWelshDPA() {
			return {
				public_url: "https://www.wonde.com/wp-content/uploads/Wonde-Data-Processing-Agreement-for-Welsh-State-Schools.docx-1-1.pdf",
				label: "Wonde's Data Processing Agreement",
			};
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/mixins/shardLinks.mixin.js